// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e8c6cf08","239":"dfdb0d71","455":"ec63873d","977":"2caed02d"}[chunkId] + ".chunk.js";
};